import urlConfig from "../../config.json";
import { BACKEND_URL } from "../../constants";
import { axios } from "../../utils/axiosConfig";

export const deleteItem = async (itemId) => {
  const ROUTE = urlConfig.backend.routes.items.deleteItem;
  const url = `${BACKEND_URL}${ROUTE}`;

  return await axios
    .delete(url, {
      data: { item_id: itemId },
    })
    .then((res) => {
      if (res.status === 200) {
        return { res: res.data, error_code: 1 };
      } else {
        return {
          error_code: 2,
          error_message: "Something Went Wrong please try again later",
        };
      }
    })
    .catch((error) => {
      if (error.response.status === 400) {
        return {
          error_code: 3,
          error_message: "Something Went Wrong please try again later",
        };
      } else {
        alert(error.response.data.message);
      }
    });
};
